export default "__VITE_ASSET__DmFYMjr6__"